import { useDeleteNote } from './hook/useDeleteNote'
import { usePostNote } from './hook/usePostNote'
import { usePutNote } from './hook/usePutNote'

class NoteService {
  api = {
    usePostNote,
    usePutNote,
    useDeleteNote
  }
}

export type { NoteSchema } from './types/Note.schema'
export const noteService = new NoteService()
